<template>
	<div class="page-wrapper container">
		<router-link class="btn btn-primary mb-2 mt-2" to="/">🏠 MC2</router-link>

		<div class="row mb-5 d-flex justify-content-center align-items-center  vh-100">
			<div class="col-md-3 mb-4">
				<router-link class="text-decoration-none" to="/kpi/payments">
					<div class="card menu-item-big" style="min-height:150px">
						<div class="card-body d-flex justify-content-center align-items-center flex-column">
							<h4 class="mb-3">Accounts Receivable</h4>
							<img src="../../assets/images/payments.svg" width="225" alt="" />
						</div>
					</div>
				</router-link>
			</div>

			<div class="col-md-3 mb-4">
				<router-link class="text-decoration-none" to="/kpi/support">
					<div class="card menu-item-big" style="min-height:150px">
						<div class="card-body d-flex justify-content-center align-items-center flex-column">
							<h4 class="mb-3">Customer Service</h4>
							<img src="../../assets/images/support.svg" width="200" alt="" />
						</div>
					</div>
				</router-link>
			</div>

			<div class="col-md-3 mb-4">
				<router-link class="text-decoration-none" to="/kpi/projects">
					<div class="card menu-item-big" style="min-height:150px">
						<div class="card-body d-flex justify-content-center align-items-center flex-column">
							<h4 class="mb-3">Project Launches</h4>
							<img src="../../assets/images/projects.svg" width="190" alt="" />
						</div>
					</div>
				</router-link>
			</div>
			<div class="col-md-3 mb-4">
				<router-link class="text-decoration-none" to="/kpi/development">
					<div class="card menu-item-big" style="min-height:150px">
						<div class="card-body d-flex justify-content-center align-items-center flex-column">
							<h4 class="mb-3">Development</h4>
							<img src="../../assets/images/projects.svg" width="190" alt="" />
						</div>
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import restApi from '../../api'
export default {
	name: 'Home',
	data() {
		return {
			loading: false,
		}
	},
	components: {},
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),
	},
	mounted() {},
	created() {},
	methods: {
		getOnboardings() {
			this.loading = true
			restApi
				.get('/onboarding', { params: { all: true } })
				.then(({ data }) => {
					this.onboardings = data
					this.totalClients = this.onboardings.length
					this.loading = false
				})
				.catch(error => {
					console.log(error)
				})
		},
	},
}
</script>
